import './toolbar.sass'

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import TrackViewOptionsSwitch from 'controls/track-view-options-switch/TrackViewOptionsSwitch';
import FormPrint from 'components/track-events/form-print/FormPrint';

export default class Toolbar extends Component {
  render() {
    return (
      <nav className="track-events-toolbar navbar navbar-default">
        <div className="container-fluid">
          <div className="navbar-header">
            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-navbar-collapse" aria-expanded="false">
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            </button>
          </div>

          <div className="collapse navbar-collapse" id="bs-navbar-collapse">
            <TrackViewOptionsSwitch
              view={ 'events' }
              trackId={ this.props.trackId }
            />
            <FormPrint
              trackId={ this.props.trackId }
            />
          </div>
        </div>
      </nav>
    );
  }
}

Toolbar.propTypes = {
  trackId: PropTypes.number.isRequired
};
